import Papa from "papaparse";
import { SAMPLE_CSV_DATA } from "../constants";
import type { ParsedBrand, RowValidationResult, ValidationResult } from "../types";

export function validateBrandRow(
  row: Record<string, string | undefined>,
  _rowIndex: number
): RowValidationResult {
  const errors: string[] = [];

  // Required fields validation
  if (!row.name?.trim()) {
    errors.push('Name is required');
  }

  if (errors.length > 0) {
    return { valid: false, errors };
  }

  // Parse and clean data
  const brand: ParsedBrand = {
    name: row.name.trim(),
    description: row.description?.trim() || undefined,
    industry: row.industry?.trim() || undefined,
    website_url: row.website_url?.trim() || undefined,
    logo_url: row.logo_url?.trim() || undefined,
  };

  return { valid: true, brand, errors: [] };
}

export function downloadBrandSampleCSV(): void {
  const blob = new Blob([SAMPLE_CSV_DATA], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'brands_sample.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function parseBrandCsvFile(
  file: File,
  onComplete: (data: { headers: string[]; previewData: Record<string, unknown>[]; validation: ValidationResult }) => void,
  onError: (error: Error) => void
): void {
  Papa.parse<Record<string, string>>(file, {
    header: true,
    skipEmptyLines: true,
    complete: (results) => {
      const data = results.data;
      const headers = Object.keys(data[0] || {});
      const previewData = data.slice(0, 5) as Record<string, unknown>[];

      const validation: ValidationResult = { valid: [], invalid: [] };

      data.forEach((row, index) => {
        const result = validateBrandRow(row, index);
        if (result.valid && result.brand) {
          validation.valid.push(result.brand);
        } else {
          validation.invalid.push({
            row: index + 1,
            errors: result.errors,
            data: row,
          });
        }
      });

      onComplete({ headers, previewData, validation });
    },
    error: (error) => {
      onError(error);
    },
  });
}
